export const getParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    try {       
        const sku_id = queryParams.get('sku_id');
        let sku_name = queryParams.get('sku_name')
        let enterprise_id = queryParams.get('enterprise_id')
        let params = sku_id ? {sku_id} : {sku_name,enterprise_id}
        return {params}
    } catch (error) {
        
    }

}